import { MobileFiltersDrawer } from "features/filters/components";
import { LEADS_FILTERS } from "features/leads/constants";
import useLeadsSearchParams from "features/leads/hooks/useLeadsSearchParams";
import type { LeadsSearchParams } from "features/leads/types";

import Switch from "common/components/ui/Switch";
import type { SelectedFacetParam } from "common/types";

import LeadsFilterOptions from "../LeadsFilterOptions";

interface MobileFiltersProps {
  searchParams: LeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: Partial<LeadsSearchParams<SelectedFacetParam>>,
  ) => void;
}

export default function MobileFilters({
  searchParams,
  setSearchParams,
}: MobileFiltersProps) {
  const { setSearchParam, resetSearchParam, resetFilters } =
    useLeadsSearchParams(searchParams, setSearchParams);

  return (
    <MobileFiltersDrawer
      title="Filter leads"
      onClear={(type) => {
        if (type === "all") {
          resetFilters();
        } else {
          resetSearchParam(type);
        }
      }}
      getSelectionCount={(filterKey) => {
        if (filterKey === "favorite") {
          return searchParams.favorite ? 1 : 0;
        }
        return searchParams[filterKey].length;
      }}
      filters={LEADS_FILTERS}
      renderFilter={(filterKey) => {
        if (filterKey === "favorite") {
          return (
            <Switch
              size="sm"
              checked={searchParams.favorite}
              onCheckedChange={(isChecked) =>
                setSearchParam("favorite", isChecked)
              }
            />
          );
        }
        return (
          <LeadsFilterOptions
            searchParamsKey={filterKey}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        );
      }}
    />
  );
}
